module.exports = __webpack_public_path__ + "img/jp-title.a532689c.png";